import React, { useState, useEffect, SetStateAction } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Row, Col } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import {
  InputField,
  InputSelectField,
} from "../../../common-components/FormComponent/FormFieldsComponent";
import { isRequiredField, isValidRegisterID, isValidNo } from "../../../common-components/FormComponent/FormValidator";
import {
  SaveButtonComponent,
} from "../../../common-components/ButtonComponent";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { Button, CircularProgress, Toolbar } from "@mui/material";
import Box from "@mui/material/Box";
import TypographyComponent from "./TableComponent/TypographyComponent";
import ToastMessage from "../../../common-components/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../../reducer-store/actions/topicAction";
import { bindActionCreators } from "redux";
import { HOURSLIMIT, LIMIT, PAGE } from "../../../reducer-store/constants";
import { toast } from "react-toastify";
import { TOPIC_SUCCESSFULLY_CREATED, TOPIC_SUCCESSFULLY_UPDATED } from "../../../reducer-store/ToastMessage";
// import { ROUTES } from "../../../constants/routes";
import { useHistory } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import MUIDataTable from "mui-datatables";
import { FaRegEdit } from "react-icons/fa";
// import { TextField, IconButton } from '@material-ui/core';
// import { SearchOutlined } from '@material-ui/icons';

type AddCoursesProps = {
  handleStep: React.Dispatch<SetStateAction<number>>;
  stepValue: number;
};
const useStyles = makeStyles(() => ({
  programCard: {
    backgroundColor: "#ececec",
  },
  button_save: {
    textAlign: "right",
  },
  backButton: {
    borderRadius: "40px !important",
    backgroundColor: "#ffffff !important",
    border: "1px solid #393939 !important",
    color: "#393939 !important",
    padding: "0 35px !important",
    height: "40px !important",
    fontWeight: 500,
    fontSize: "0.875rem",
    fontFamily: 'Arial !important',
    lineHeight: 1.75,
    letterSpacing: "0.02857em",
    textTransform: 'capitalize',
    minWidth: "64px",
  },
  searchBar: {
    borderColor: "black",
    "& hover": {
      borderColor: "black"
    },
    "& focused": {
      borderColor: "black"
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "black"
    }
  }
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const theme = createTheme({
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: {
          overflow: "hidden",
          color: '#FFFFFF',
          "& .css-1ygcj2i-MuiTableCell-root": {
            color: "#FFFFFF",
            fontweight: "bold",
          },
          "& .tss-1fz4yw6-MUIDataTableSelectCell-fixedLeft": {
            backgroundColor: "#404040",
          },
          "& .tss-1akey0g-MUIDataTableHeadCell-data": {
            color: "white",
          },
          "& .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon ": {
            color: "white"
          },
          "& .tss-1h9t3sl-MUIDataTableHeadCell-sortAction": {
            display: "-webkit-box"
          },
          "& .css-11k72hi-MuiTableCell-root.MuiTableCell-head": {
            backgroundColor: "#646464",
          },
          "& .css-pfof31-MuiTableCell-root ": {
            color: "#FFFFFF"
          },
          "& .tss-10syd3x-MUIDataTableHeadCell-root": {
            fontSize: '15px',
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Arial"
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "Arial",
        },
        head: {
          backgroundColor: "#404040",
          color: '#FFFFFF'
        },
        footer: {
          backgroundColor: "#FFFFFF",
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: "#DFDFDF"
          },
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "Arial"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        colorInherit: {
          backgroundColor: '#E53D12',
          borderRadius: '4px',
          color: 'white',
          marginRight: '25px',
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .css-1ex1afd-MuiTableCell-root": {
            width: "18%",
          }
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          "& .MuiTablePagination-displayedRows": {
            marginTop: "9%"
          },
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Arial",
          "& .css-140puxv-MuiTypography-root-MuiDialogTitle-root": {
            backgroundColor: '#646464'
          }

        }
      }
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          fill: '#FFFFFF'
        }
      }
    }
  }
});

function createData(
  TopicName: string,
  TotalHours: number,
  InclassTrainingHours: number,
  InyardTrainingHours: number,
  IncabTrainingHours: number
) {
  return {
    TopicName,
    TotalHours,
    InclassTrainingHours,
    InyardTrainingHours,
    IncabTrainingHours,
  };
}

const rows = [
  createData("Topic Name 1", 50, 30, 10, 10),
  createData("Topic Name 2", 50, 30, 10, 10),
];
// end table

export default function AddTopics({ handleStep, stepValue }: AddCoursesProps) {
  const [Courses, setCourses] = useState("");
  const [Modual, setModual] = useState("");
  const [topicVisible, setTopicVisible] = useState(true);
  const [Program, setProgram] = useState("");
  const [TopicName, setTopicName] = useState("");
  const [TotalHours, setTotalHours] = useState<any>("");
  const [InclassTrainingHours, setInclassTrainingHours] = useState<any | number>("");
  const [InyardTrainingHours, setInyardTrainingHours] = useState<any>("");
  const [IncabTrainingHours, setIncabTrainingHours] = useState<any>("");
  const [Description, setDescription] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidValues, setIsValidValues] = useState(true);
  const dispatch = useDispatch();
  const { TopicList } = bindActionCreators(Actions, dispatch);
  const [rowsPerPage, setRowsPerPage] = useState(1000);
  const [page, setPage] = useState(PAGE);
  const AuthToken = useSelector((state: any) => state.auth);
  const { token } = AuthToken;
  const topicList = useSelector((state: any) => state.topic);
  const { topics } = topicList;
  const [topicId, setTopicId] = useState("")
  const history = useHistory();
  /* const [courseArr, setCourseArr] = useState([{ id: "", name: "Select course" }]); */
  const [saveUpdate, setSaveUpdate] = useState(true)
  const [isSaving, setIsSaving] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [courseList, setCourseList] = useState<any>([{ id: "", name: "Select Course" }])
  const [moduleList, setModuleList] = useState<any>([{ id: "", name: "Select Module" }])
  // const [programList, setProgramList] = useState([{ id: "", name: "Select Program" }])
  const [programName, setProgramName] = useState("");
  const [programId, setProgramId] = useState("");
  const [data, setData] = useState([]);
  const [addCourseVisible, setAddCourseVisible] = useState(false);
  const [searchApiData, setSearchApiData] = useState([]);
  const [filterVal, setFilterVal] = useState('');
  const classes = useStyles();

  // const handleFilter = (e: any) => {
  //   if (e.target.value == "") {
  //     setData(searchApiData);
  //   } else {
  //     const filterData = searchApiData.filter((items: any) =>
  //       items.topic_name.toLowerCase().includes(e.target.value.toLowerCase())
  //       || items.inclass.toString().includes(e.target.value.toString())
  //       || items.inyard.toString().includes(e.target.value.toString())
  //       || items.hours.toString().includes(e.target.value.toString())
  //       || items.incab.toString().includes(e.target.value.toString()));
  //     setData(filterData);
  //   }
  //   setFilterVal(e.target.value);
  // };

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  useEffect(() => {
    (async () => {
      const programId: any = sessionStorage.getItem("program_id");
      setProgramId(programId)
      const program_name: any = sessionStorage.getItem("program_name");
      setProgramName(program_name);
      const moduleArr = await Actions.DropDownModualList(page, programId, token)
      // const programArr = await Actions.DropDownProgramList(page, token)
      setModuleList([...moduleList, ...moduleArr.data])
      // setProgramList([...programList, ...programArr.data])
    })();
  }, [programId])

  useEffect(() => {
    (async () => {
      setTableLoading(true);
      try {
        const programId: any = sessionStorage.getItem("program_id");
        setProgramId(programId)
        const program_name: any = sessionStorage.getItem("program_name");
        setProgramName(program_name);
        const newTopicList = await TopicList(page, programId, rowsPerPage, token);
        renderDataTable(newTopicList);
      } finally {
        setTableLoading(false);
      }
    })();
  }, [page, saveUpdate, addCourseVisible]);

  useEffect(() => {
    (async () => {
      if (Modual === null || Modual === "") {
        return;
      } else {
        const courseArr = await Actions.DropDownCourseList(page, Modual, token);
        setCourseList(courseArr.data.length > 0 ? [{ id: "", name: "Select Course" }, ...courseArr.data] : [{ id: "", name: "No Course Found" }])
      }
    })();
  }, [Modual])

  const handleBack = () => {
    handleStep((stepValue) => stepValue - 1);
  };

  const handleCancel = () => {
    resetData();
    setSaveUpdate(true);
    setIsSubmit(false);
  }

  const resetData = () => {
    // setCourses("");
    // setModual("");
    setProgram("");
    setTopicName("");
    setTotalHours("");
    setInclassTrainingHours("");
    setInyardTrainingHours("");
    setIncabTrainingHours("");
    setDescription("");
  };

  const SubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmit(true);
    if (
      isRequiredField(Courses) &&
      isRequiredField(Modual) &&
      // isRequiredField(Program) &&
      isRequiredField(TopicName) &&
      isRequiredField(InclassTrainingHours) &&
      isRequiredField(InyardTrainingHours) &&
      isRequiredField(IncabTrainingHours) &&
      isRequiredField(Description)
    ) {
      setIsSubmit(false);
      setIsSaving(true);
      try {
      let topicObj = {
        program_id: programId,
        module_id: Modual,
        course_id: Courses,
        name: TopicName,
        description: Description,
        duration_minutes: Math.floor(InclassTrainingHours * 60) + Math.floor(InyardTrainingHours * 60) + Math.floor(IncabTrainingHours * 60),
        inclass_training_minutes: Math.floor(InclassTrainingHours * 60),
        inyard_training_minutes: Math.floor(InyardTrainingHours * 60),
        incab_training_minutes: Math.floor(IncabTrainingHours * 60),
        total_score: 100,
        status: 1,
      };

      let resData: any = saveUpdate ? await Actions.addTopic(topicObj, token) : await Actions.UpdateTopic(
        topicId,
        topicObj,
        token
      );
      if (!resData.error) {
        toast.success(saveUpdate ? TOPIC_SUCCESSFULLY_CREATED : TOPIC_SUCCESSFULLY_UPDATED);
        const topicList: any = TopicList(page, programId, rowsPerPage, token);
        setTimeout(() => {
          setAddCourseVisible(!addCourseVisible);
          resetData();
          setSaveUpdate(true);
          // saveUpdate ? /* handleStep((stepValue) => stepValue + 1) */ history.push(ROUTES.programs) : TopicList(page, rowsPerPage, token) && setSaveUpdate(!saveUpdate);
        }, 2000);
      }
      } finally {
        setIsSaving(false);
      }
    }
    setIsValidValues(false);
  };

  const handleEditTopics = async (row: any) => {
    window.scrollTo(0, 0);
    setTopicId(row.id)
    setCourses(row.course_id)
    setModual(row.module_id)
    setProgram(row.program_id)
    setTopicName(row.name)
    setTotalHours(row.duration_minutes / 60)
    setInclassTrainingHours(row.inclass_training_minutes / 60)
    setInyardTrainingHours(row.inyard_training_minutes / 60)
    setIncabTrainingHours(row.incab_training_minutes / 60)
    setDescription(row.description)
    setSaveUpdate(!saveUpdate)
  };

  const renderDataTable = (newtopicList: any) => {
    const rowsDataTable = newtopicList && newtopicList.data.data.map((row: any) => {
      return {
        topic_name: row.name !== null ? row.name : "---",
        course_name: row.Course?.name !== null ? row.Course?.name : "---",
        module_name: row.ProgramModule?.name !== null ? row?.ProgramModule?.name : "---",
        hours: row.duration_minutes !== null ? row.duration_minutes / 60 : "---",
        inclass: row.inclass_training_minutes !== null ? row.inclass_training_minutes / 60 : "---",
        inyard: row.inyard_training_minutes !== null ? row.inyard_training_minutes / 60 : "---",
        incab: row.incab_training_minutes !== null ? row.incab_training_minutes / 60 : "---",
        description: row.description,
        edit: <FaRegEdit size={18} style={{ cursor: 'pointer' }} onClick={() => handleEditTopics(row)} />
      };
    });
    setData(rowsDataTable);
    setSearchApiData(rowsDataTable);
  };

  const columns = [
    {
      label: 'Topic Name',
      name: "topic_name",
    },
    {
      label: 'Course Name',
      name: "course_name",
    },
    {
      label: 'Module Name',
      name: "module_name",
    },
    {
      label: 'Total Hours',
      name: "hours",
    },
    {
      label: 'Total Inclass Training Hours',
      name: "inclass",
    },
    {
      label: 'Total Inyard Training Hours',
      name: "inyard",
    },
    {
      label: 'Total Incab Training Hours',
      name: "incab",
    },
    {
      label: "Des",
      name: "description",
      options: {
        display: false,
      }
    },
    {
      label: 'Edit',
      name: "edit",
      options: {
        sort: false
      }
    },
  ];

  const options = {
    responsive: "vertical" as const,
    search: false,
    print: false,
    viewColumns: false,
    filter: false,
    download: false,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    selectableRows: "none" as const,
    rowsPerPageOptions: [],
    fixedHeader: false,
    textLabels: {
      body: {
        noMatch: tableLoading ? (
          <Box style={{ textAlign: 'center', margin: '0 auto' }}>
            <CircularProgress sx={{ color: '#707070' }} />
          </Box>
        ) : 'Sorry, there is no matching data to display',
      },
    },
    // customToolbar: () => {
    //   return (<>
    //     <TextField
    //       variant="standard"
    //       placeholder="Search"
    //       onInput={(e: any) => handleFilter(e)}
    //       value={filterVal}
    //       className={classes.searchBar}
    //       InputProps={{
    //         style: { color: "black" },
    //         endAdornment: (
    //           <IconButton>
    //             <SearchOutlined />
    //           </IconButton>
    //         ),
    //       }}
    //     />

    //   </>)
    // },
    renderExpandableRow: (rowData: any) => {
      return (
        <StyledTableRow >
          <StyledTableCell
            style={{ paddingBottom: 0, paddingTop: 0 }}
            colSpan={9}
          >
            <Box sx={{ margin: 1 }}>
              <Typography fontWeight={700} color="#404040">
                Description :
              </Typography>
              <Typography color="#606060">
                {rowData[7]}
              </Typography>
            </Box>
          </StyledTableCell>
        </StyledTableRow>
      );
    },
  };

  const onChangeHours = (value: any, setMethod: any) => {
    const re = /^(?=.*[1-9])\d+(?:\.[05]0?)?$/;
    if (value === '' || re.test(value))
      setMethod(value);
  }

  const onChangeProgram = (value: any, setMethod: any) => {
    var regexp = /^[a-zA-Z0-9_]+$/;
    if (value === '' || regexp.test(value))
      setMethod(value);
  }

  return (
    <>
      <ToastMessage />
      <form onSubmit={SubmitHandler}>
        <Card className={classes.programCard}>
          <CardContent>
            <Row>
              <Col lg="4" sm="12">
                <InputField
                  disabled
                  type="text"
                  lable="Program Program"
                  name={programName}
                  value={programName}
                  rows={1}
                  multiline={false}
                  placeHolder="Enter Program Name"
                  className="form-textfield-styles"
                  isValidValue={false}
                  isSubmit={false}
                  requiredMessage="Program field is required"
                />
              </Col>
              <Col lg="4" sm="12">
                <InputSelectField
                  select={true}
                  lable="Select Module"
                  name={Modual}
                  value={Modual}
                  className="form-textfield-styles"
                  options={moduleList}
                  handleChange={(e) => setModual(e.target.value)}
                  isValidValue={isValidValues}
                  isSubmit={isSubmit}
                  requiredMessage="Module field is required"
                />
              </Col>
              <Col lg="4" sm="12">
                <InputSelectField
                  // disabled={!saveUpdate ? true : false}
                  select={true}
                  lable="Select Courses"
                  name={Courses}
                  value={Courses}
                  className="form-textfield-styles"
                  options={courseList}
                  handleChange={(e) => setCourses(e.target.value)}
                  isValidValue={isValidValues}
                  isSubmit={isSubmit}
                  requiredMessage="Courses field is required"
                />
              </Col>
              <Col lg="4" sm="12">
                <InputField
                  disabled={topicVisible || saveUpdate ? false : true}
                  type="text"
                  lable="Topic Name"
                  name={TopicName}
                  rows={1}
                  multiline={false}
                  placeHolder="Enter Topic Name"
                  className="form-textfield-styles"
                  value={TopicName}
                  handleChange={(e) => onChangeProgram(e.target.value, setTopicName)}
                  isValidValue={false}
                  isSubmit={false}
                  requiredMessage="Topic Name field is required"
                  isCheckValidRID={true}
                />
              </Col>
              {
                saveUpdate ? "" :
                  <Col lg="4" sm="12">
                    <Typography className="fontLabel">
                      Total Hours
                    </Typography>
                    <Typography>
                      {TotalHours !== null ? TotalHours : "---"}
                      <hr style={{ marginTop: 5 }} />
                    </Typography>
                  </Col>
              }
              <Col lg="4" sm="12">
                <InputField
                  type="number"
                  lable="Total Inclass Training Hours"
                  name={InclassTrainingHours}
                  rows={1}
                  multiline={false}
                  placeHolder="Enter Inclass Training Hours"
                  className="form-textfield-styles"
                  value={InclassTrainingHours}
                  handleChange={(e) => onChangeHours(e.target.value.slice(0, 3), setInclassTrainingHours)}
                  // setInclassTrainingHours(e.target.value.slice(0, HOURSLIMIT))
                  isValidValue={false}
                  isSubmit={isSubmit}
                  requiredMessage="Inclass Training Hours field is required"
                  disablePrevious="0"
                />
              </Col>

              <Col lg="4" sm="12">
                <InputField
                  type="number"
                  lable="Total Inyard Training Hours"
                  name={InyardTrainingHours}
                  rows={1}
                  multiline={false}
                  placeHolder="Enter Inyard Training Hours"
                  className="form-textfield-styles"
                  value={InyardTrainingHours}
                  handleChange={(e) => onChangeHours(e.target.value.slice(0, 3), setInyardTrainingHours)}
                  isValidValue={false}
                  isSubmit={isSubmit}
                  requiredMessage="Inyard Training Hours field is required"
                  disablePrevious="0"
                />
              </Col>
              <Col lg="4" sm="12">
                <InputField
                  type="number"
                  lable="Total Incab Training Hours"
                  name={IncabTrainingHours}
                  rows={1}
                  multiline={false}
                  placeHolder="Enter Incab Training Hours"
                  className="form-textfield-styles"
                  value={IncabTrainingHours}
                  handleChange={(e) => onChangeHours(e.target.value.slice(0, 3), setIncabTrainingHours)}
                  isValidValue={false}
                  isSubmit={isSubmit}
                  requiredMessage="Incab Training Hours field is required"
                  disablePrevious="0"
                />
              </Col>

              <Col lg="12" sm="12">
                <InputField
                  type="text"
                  lable="Description"
                  name={Description}
                  rows={5}
                  multiline={true}
                  placeHolder="Enter Description"
                  className="form-textfield-styles"
                  value={Description}
                  handleChange={(e) => setDescription(e.target.value)}
                  isValidValue={isValidValues}
                  isSubmit={isSubmit}
                  requiredMessage="Description field is required"
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Col lg="12" sm="12">
                <div className={classes.button_save}>
                  <Button
                    variant="outlined"
                    onClick={handleCancel}
                    className={classes.backButton}
                  >
                    Cancel
                  </Button>
                  {" "}
                  <SaveButtonComponent
                    ButtonType="submit"
                    ButtonLabel={isSaving ? (saveUpdate ? "Saving..." : "Updating...") : (saveUpdate ? "Save" : "Update")}
                    loading={isSaving}
                    disabled={isSaving}
                  />
                  {" "}
                </div>
              </Col>
            </Row>
          </CardContent>
        </Card>
        <TypographyComponent label="Topics List" />

        <ThemeProvider theme={theme} >
          <MUIDataTable
            title={""}
            data={data}
            columns={columns}
            options={options}
          />
        </ThemeProvider >

        <Row className="mt-4">
          <Col lg="12" sm="12">
            <div className="stepperButton">
              <Button
                variant="outlined"
                onClick={handleBack}
                className={classes.backButton}
              >
                Back
              </Button>{" "}
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};